import { render, staticRenderFns } from "./Attestation.vue?vue&type=template&id=39305c87&scoped=true"
import script from "./Attestation.vue?vue&type=script&lang=js"
export * from "./Attestation.vue?vue&type=script&lang=js"
import style0 from "@/assets/pdf/css/default.less?vue&type=style&index=0&id=39305c87&prod&scoped=true&lang=less&external"
import style1 from "./Attestation.vue?vue&type=style&index=1&id=39305c87&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39305c87",
  null
  
)

export default component.exports